import Pointer from "@/Icons/Pointer";
import { formatNumberForTable } from "@/Utils/formatFunctions";
import { DeltaTrend } from "@/Utils/tableColumns/functions";

import React from "react";

import { twMerge } from "tailwind-merge";

export const calculateUnitSpace = (unit: string): string =>
  unit === "kg" ? " " : "";
const getTrendColor = (trend: DeltaTrend) => {
  if (trend === DeltaTrend.Positive) return "text-carrot-green";
  if (trend === DeltaTrend.Negative) return "text-carrot-red";
  if (trend === DeltaTrend.Neutral) return "text-grey6";
  return undefined;
};

export const UnitDiff: React.FC<{
  diff: number;
  unit: string;
  trend: DeltaTrend;
}> = ({ diff, unit, trend }) => {
  const percentUnits = unit === "percent";
  const suffix = percentUnits ? " %" : " kg";
  return (
    <div
      className={twMerge(
        "font-dm-sans flex h-4 justify-items-center justify-self-end text-sm",
        getTrendColor(trend),
      )}
    >
      <Pointer
        className={twMerge(
          "mr-1",
          diff > 0 && "rotate-180",
          diff === 0 && "hidden",
        )}
      />
      {formatNumberForTable(diff, { suffix })}
    </div>
  );
};

export default UnitDiff;
